import React, { Component } from 'react';
import './about-us.css';

import natashaPhoto from './img/nataly.png';
import eugenePhoto from './img/evgeni0us.jpg';

const teamMembers = [
    {
        key: "natasha",
        photo: natashaPhoto,
        name: 'Natasha',
        title: 'Software Developer and Co-Founder',
    },
    {
        key: "eugene",
        photo: eugenePhoto,
        name: 'Eugene',
        title: 'Software Developer and Co-Founder',
    }];

class AboutUs extends Component {
  render() {
    return (
        <div className="text-dark">
            <h1 className="mb-4 text-white">Our team</h1>

            <div className="row justify-content-md-center">
                {teamMembers.map(function(member, i){
                        return <div className="app-item col-sm-12 col-md-6 col-lg-5 col-xl-4" key={member.key}>
                                    <div className="m-3 card-team-member rounded pt-5 p-3">
                                        <img src={member.photo} className="rounded img-photo mx-auto mb-3" alt={member.name}/>
                                        <h1 className="">{member.name}</h1>
                                        <div className="m-3 text-center">{member.title}</div>
                                    </div>
                                </div>;
                    })}
            </div>
            <div className="row text-center pt-5 pb-5" id="contact">
                <div className="col-12">
                    <p className="lead text-white pb-3 feedback">We will be happy to have your feedback. Please do write to us.</p>
                    <a href="mailto:igrecway@gmail.com" className="btn btn-contact text-white">Contact us</a>
                </div>
            </div>
        </div>
    );
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/about-us/about-us.js